import { useState } from 'react';

export default function Slider({ value, setValue, disabled = false }) {
    const [isDragging, setIsDragging] = useState(false);

    const handleMouseDown = () => {
        if (disabled) return;
        setIsDragging(true);
    };

    const handleMouseUp = () => {
        if (disabled) return;
        setIsDragging(false);
    };

    const handleMouseMove = (e) => {
        if (disabled || !isDragging) return;
        updateValue(e.clientX);
    };

    const handleClick = (e) => {
        if (disabled) return;
        updateValue(e.clientX);
    };

    const updateValue = (clientX) => {
        const slider = document.getElementById('slider-track');
        if (!slider) return;
        const rect = slider.getBoundingClientRect();
        const percentage = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
        setValue(Math.round(percentage));
    };

    return (
        <div
            className="flex items-center gap-4 select-none"
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
        >
            <div
                id="slider-track"
                className={`relative flex-1 h-1 mb-2 rounded-full cursor-pointer transition-colors ${disabled ? 'bg-gray-200 cursor-not-allowed' : 'bg-gray-300'
                    }`}
                onClick={handleClick}
            >
                <div
                    className={`absolute h-1 rounded-full transition-colors ${disabled ? 'bg-gray-400' : 'bg-blue-500'
                        }`}
                    style={{ width: `${value}%` }}
                />

                <div
                    className={`absolute top-1/2 -translate-y-1/2 w-3 h-3 rounded-full shadow-md transition-all ${disabled
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-blue-500 cursor-grab active:cursor-grabbing'
                        }`}
                    style={{ left: `${value}%`, transform: 'translate(-50%, -50%)' }}
                    onMouseDown={handleMouseDown}
                />
            </div>

            <div
                className={`min-w-[80px] p-1 font-normal border rounded-lg text-center ${disabled
                    ? 'text-gray-400 border-gray-200 bg-gray-100'
                    : 'text-gray-700 border-gray-300'
                    }`}
            >
                {value}
            </div>
        </div>
    );
}
